import { render } from "./GaugesDashboard.vue?vue&type=template&id=a5048306&scoped=true"
import script from "./GaugesDashboard.vue?vue&type=script&lang=js"
export * from "./GaugesDashboard.vue?vue&type=script&lang=js"

import "./GaugesDashboard.vue?vue&type=style&index=0&id=a5048306&scoped=true&lang=css"

import exportComponent from "/var/www/bauminas/hml/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5048306"]])

export default __exports__